import React, { useEffect } from "react";

const VideoPlayer = ({ embedCode }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Component kaldırıldığında script'i temizle
      document.body.removeChild(script);
    };
  }, []);

  return <div className="videoContainer" dangerouslySetInnerHTML={{ __html: embedCode }} />;
};

export default VideoPlayer;
